/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OrderByPropertyDto = {
  /**
   * The property name to order by
   */
  propertyName: string;
  /**
   * The order direction (asc or desc)
   */
  value: OrderByPropertyDto.value;
};
export namespace OrderByPropertyDto {
  /**
   * The order direction (asc or desc)
   */
  export enum value {
    ASC = 'asc',
    DESC = 'desc',
  }
}
